import React from 'react'

import { carData as CData } from '../../../data/car.data'

import {cotizadorData as CoData} from '../../../data/cotiza.data'
import { modelsData } from '../../../data/models.data'

import backBtn from './../../../UI/canvas/CarMenu/btns/back-btn.svg'

interface Props{
    isCarMenuOpened: boolean,
    selectedIndividual: string,
    contextualMenu: boolean,
    handleContextualMenu: any,
    handleSelectedMenuElement: any,
    handleBtnClick: any,
    btnSelectedIndex: number
}

interface State{
    VehicleData : any,
    btnHover: boolean,
    btnHoverIndex: number,
    btnSelectedIndex: number,
    btnSubHoverIndex: number,
    subBtnSelectedIndex:number
}

class CarMenuMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            VehicleData: CData()[0],
            btnHover: false,
            btnHoverIndex: -1,
            btnSelectedIndex: -1,
            btnSubHoverIndex: -1,
            subBtnSelectedIndex: -1
        }
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps: any){
        if(this.props.selectedIndividual !== prevProps.selectedIndividual){
            this.setState({
                VehicleData: CData()[0][this.props.selectedIndividual],
                btnHoverIndex: -1,
                btnSelectedIndex: -1,
                btnSubHoverIndex: -1,
                subBtnSelectedIndex: -1
            })
        }
    }

    handleGenerateStructure = () => {
        if(this.props.selectedIndividual !== "" && this.state.VehicleData && this.state.VehicleData.Menu){
            return(
                this.state.VehicleData.Menu.map((data: any, index: number) => 
                    <React.Fragment key={index}>
                        {
                            index === 4 ?
                            <div 
                                    className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? 'individual-btn-carmenu-mobile btn-hovered':'individual-btn-carmenu-mobile'} 
                                    onMouseEnter={() => {this.handleBtnHover(true, index)}} 
                                    onMouseLeave = {() => {this.handleBtnHover(false, -1)}}
                                    onClick = {() => {this.props.handleBtnClick(this.state.btnSelectedIndex === index ? -1:index, data.Slug)}}
                                    
                                >
                                    <a href={CoData()[0][this.props.selectedIndividual]} target="_blank" style={{textDecoration: "none"}}>
                                    <img src={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? data.Icono2.default:data.Icono.default} alt=""/>
                                    <div className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? "text-btn-carmenu-hovered-mobile":"text-btn-carmenu-mobile"}>{data.Nombre}</div>
                                </a>
                                    
                                </div>
                            :
                            <div 
                            className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? 'individual-btn-carmenu-mobile btn-hovered':'individual-btn-carmenu-mobile'} 
                            onMouseEnter={() => {this.handleBtnHover(true, index)}} 
                            onMouseLeave = {() => {this.handleBtnHover(false, -1)}}
                            onClick = {() => {this.props.handleBtnClick(this.state.btnSelectedIndex === index ? -1:index, data.Slug)}}
                            
                        >
                            <img src={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? data.Icono2.default:data.Icono.default} alt=""/>
                            <div className={(this.state.btnHover && this.state.btnHoverIndex === index) || this.props.btnSelectedIndex === index ? "text-btn-carmenu-hovered-mobile":"text-btn-carmenu-mobile"}>{data.Nombre}</div>
                        </div>
                        }
                        {modelsData()[0][this.props.selectedIndividual] === undefined ? 
                            <div className={data.SubMenu.length > 0 && this.props.btnSelectedIndex === index ? 'container-sub-menu-mobile fade-in':'container-sub-menu-collapsed-mobile fade-out'} >
                            {data.SubMenu.map((submenu: any, indexIndv: number) => 
                                <div 
                                    className={this.props.btnSelectedIndex === index ? this.state.subBtnSelectedIndex === indexIndv ?  `container-sub-container-selected-mobile-${indexIndv} fade-in`:`container-sub-container-mobile-${indexIndv} fade-in`:'container-sub-container-collapsed fade-out'}
                                    key={indexIndv}
                                    onMouseEnter = {() => {this.handleSubBtnHover(indexIndv)}}
                                    onMouseLeave = {() => {this.handleSubBtnHover(-1)}}
                                    onClick = {() => {this.handleSubBtnClick(indexIndv, data.Slug)}}
                                >
                                    <div className={this.state.btnSubHoverIndex === indexIndv || this.state.subBtnSelectedIndex === indexIndv ? 'container-sub-text-selected-mobile':'container-sub-text-mobile'}>{submenu.Nombre}</div>
                                </div>
                            )}
                            {
                                <div className={this.props.btnSelectedIndex === index  ? "back-btn-mobile fade-in":"back-btn-mobile fade-out"} onClick={() => {this.handleSubBtnClick(-1, '')}}>
                                    <img src={backBtn}/>
                                    <div className='btc-btn-text'>
                                        Volver
                                    </div>
                                </div>
                            }
                        </div>:null
                        }
                    </React.Fragment>
                )
            )
        }
    }

    handleBtnHover = (payload: boolean, index: number) => {
        this.setState({
            btnHover: payload,
            btnHoverIndex: index
        })
    }

    handleSubBtnHover = (index: number) => {
        this.setState({
            btnSubHoverIndex: index
        })
    }

    handleSubBtnClick = (index: number, payload: string) => {
        this.setState(prevState => ({
            subBtnSelectedIndex: prevState.subBtnSelectedIndex === index ? -1: index
        }), () => {
            this.props.handleSelectedMenuElement(this.props.btnSelectedIndex, payload, this.state.subBtnSelectedIndex)
        })

        
    }

    handleBtnClick = (payload: number) => {
        this.setState({
            btnSelectedIndex: payload
        }, () => {
            this.props.handleSelectedMenuElement(this.state.btnHoverIndex, -1)
        })
    }

    render(): React.ReactNode {
        return(
            <div 
                className={this.props.isCarMenuOpened && this.props.selectedIndividual !== "" ? 'carmenu-main-mobile-opened fade-in': 'carmenu-main-mobile fade-out'}
                style={{
                    pointerEvents:"none"
                }}
            >
                <div 
                    className={this.props.isCarMenuOpened ? 'carmenu-cont-menu-mobile fade-in':'carmenu-cont-menu-mobile fade-out'}
                    style={{pointerEvents: this.props.contextualMenu && this.props.isCarMenuOpened  ? "visibleFill":"none"}}
                >
                    <div className='carmenu-title-container-mobile'>
                        <div className='carmenu-cont-title-mobile'>
                            {this.state.VehicleData ? this.state.VehicleData.Nombre + " " + this.state.VehicleData.SubTitle  :""}
                        </div>
                    </div>
                    <div className='carmenu-btn-container-mobile'>
                        {
                            this.handleGenerateStructure()
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default CarMenuMobile